const FAIL_LOAD_CAPTCHA_ERROR_MESSAGE = 'Failed to load grecaptcha enterprise';
export const RECAPTCHA_SCRIPT_URL = 'https://www.recaptcha.net/recaptcha/enterprise.js';
const RECAPTCHA_BADGE_SELECTOR = '.grecaptcha-badge';
export const loadRecaptcha = siteKey => new Promise((resolve, reject) => {
  if (isRecaptchaLoaded(siteKey)) {
    resolve();
    return;
  }
  const scriptElement = document.createElement('script');
  scriptElement.src = `${RECAPTCHA_SCRIPT_URL}?render=${siteKey}`;
  scriptElement.async = true;
  scriptElement.defer = true;
  scriptElement.id = siteKey;
  scriptElement.onload = () => {
    var _window, _window$grecaptcha;
    if (!((_window = window) !== null && _window !== void 0 && (_window$grecaptcha = _window.grecaptcha) !== null && _window$grecaptcha !== void 0 && _window$grecaptcha.enterprise)) {
      reject(FAIL_LOAD_CAPTCHA_ERROR_MESSAGE);
    } else {
      window.grecaptcha.enterprise.ready(resolve);
    }
  };
  scriptElement.onerror = error => {
    var _message;
    reject(typeof error === 'string' ? error : (_message = error.message) !== null && _message !== void 0 ? _message : FAIL_LOAD_CAPTCHA_ERROR_MESSAGE);
  };
  document.body.appendChild(scriptElement);
});
const isRecaptchaLoaded = siteKey => Boolean(document.getElementById(siteKey));
export const unloadRecaptcha = siteKey => {
  removeRecaptchaScriptElement(siteKey);
  removeRecaptchaBadgeStyleElement(siteKey);
  removeRecaptchaBadge();
};
export const hideRecaptchaBadge = siteKey => {
  const id = `${siteKey}-styles`;
  if (document.getElementById(id)) {
    return;
  }
  const styleElement = document.createElement('style');
  styleElement.id = `${siteKey}-styles`;
  styleElement.innerText = `${RECAPTCHA_BADGE_SELECTOR} { visibility: hidden; }`;
  document.head.appendChild(styleElement);
};
const removeRecaptchaScriptElement = siteKey => {
  const scriptElement = document.getElementById(siteKey);
  if (scriptElement) {
    scriptElement.remove();
  }
};
const removeRecaptchaBadgeStyleElement = siteKey => {
  const styleElement = document.getElementById(`${siteKey}-styles`);
  if (styleElement) {
    styleElement.remove();
  }
};
const removeRecaptchaBadge = () => {
  const badgeElements = document.querySelectorAll(RECAPTCHA_BADGE_SELECTOR);
  for (const el of badgeElements) {
    el.remove();
  }
};
export class RecaptchaError extends Error {
  constructor(message) {
    super(message);

    // fixing the `instanceof` operators, see https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
    Object.setPrototypeOf(this, RecaptchaError.prototype);
  }
}